import React, { useMemo } from "react";
import { Grid } from "@mui/material";
import DecoSelect from "./DecoSelect";
import DecoAutocomplete from "./DecoAutocomplete";
import { countertopscolors, countertops } from "../constants/closetOptions";

const CountertopOptions = ({
  countertopType,
  setCountertopType,
  countertopColor,
  setCountertopColor,
  countertopCollection,
  setCountertopCollection,
}) => {
  const availableColors = useMemo(
    () => countertopscolors[countertopType] || [],
    [countertopType]
  );
  const availableCollections = useMemo(
    () => countertops[countertopType] || [],
    [countertopType]
  );

  const isSpecialColor = [
    "Winter Fun", "White Chocolate", "Sunset Cruise", "After Hours",
    "First Class", "Fashionista", "Sheer Beauty", "Free Spirit",
    "Rhapsody", "Chameleon",
  ].includes(countertopColor);

  const collectionOptions = isSpecialColor ? ["Curated"] : availableCollections;

  return (
    <>
      <Grid item xs={6}>
        <DecoSelect
          labelId="countertop-type-label"
          value={countertopType}
          onChange={(e) => setCountertopType(e.target.value)}
          menuItems={Object.keys(countertops)}
          label="Countertop Type"
          isError={!countertopType}
        />
      </Grid>
      {countertopType && (
        <>
          <Grid item xs={6}>
            <DecoAutocomplete
              labelId="countertop-color-label"
              value={countertopColor}
              onChange={(e) => setCountertopColor(e.target.value)}
              menuItems={availableColors}
              label="Countertop Color"
              isError={!countertopColor}
            />
          </Grid>
          {countertopColor && (
            <Grid item xs={6}>
              <DecoSelect
                labelId="countertop-collection-label"
                value={countertopCollection}
                onChange={(e) => setCountertopCollection(e.target.value)}
                menuItems={collectionOptions}
                label="Countertop Edge"
                isError={!countertopCollection}
              />
            </Grid>
          )}
        </>
      )}
    </>
  );
};

export default CountertopOptions;
